// import components
import {
  Paper,
  styled,
  TableContainer,
  TableContainerProps
} from '@mui/material';

export const StyledTableContainer = styled((props: TableContainerProps) => (
  <TableContainer {...props} component={Paper} />
))(({ theme }) => ({
  borderRadius: theme.shape.borderRadius
}));
